export enum EUnitType {
  Vien = 'vien',
  Hop = 'hop',
  Bich = 'bich',
  Cai = 'cai',
  Chai = 'chai',
  Loc = 'loc',
  Ong = 'ong',
  Tuyp = 'tuyt',
  Lieu = 'lieu',
  Goi = 'goi',
  Hu = 'hu',
  Tui = 'tui',
  Kit = 'kit',
  Binh = 'binh',
  Bo = 'bo',
  Nang = 'nang',
  QueCay = 'que-cay',
  ThanhCay = 'thanh-cay',
  Thung = 'thung',
  Vi = 'vi',
  Ml = 'ml',
  Mg = 'mg',
  UI = 'ui',
  Giot = 'giot',
  ThiaCafe = 'thia-cafe',
  IU = 'iu',
  Muong = 'muong',
  Mieng = 'mieng',
  Lan = 'lan',
  LanXit = 'lan-xit',
  Cuon = 'cuon',
  Lo = 'lo'
}

export enum EUnitType2 {
  Vien = 'vien2',
  Hop = 'hop2',
  Bich = 'bich2',
  Cai = 'cai2',
  Chai = 'chai2',
  Loc = 'loc2',
  Ong = 'ong2',
  Tuyp = 'tuyt2',
  Lieu = 'lieu2',
  Goi = 'goi2',
  Hu = 'hu2',
  Tui = 'tui2',
  Kit = 'kit2',
  Binh = 'binh2',
  Bo = 'bo2',
  Nang = 'nang2',
  QueCay = 'que-cay2',
  ThanhCay = 'thanh-cay2',
  Thung = 'thung2',
  Vi = 'vi2',
  Ml = 'ml2',
  Mg = 'mg2',
  UI = 'ui2',
  Giot = 'giot2',
  ThiaCafe = 'thia-cafe2',
  IU = 'iu2',
  Muong = 'muong2',
  Mieng = 'mieng2',
  Lan = 'lan2',
  LanXit = 'lan-xit2',
  Cuon = 'cuon2',
  Lo = 'lo2'
}
